var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6514 3.47123L11.6493 3.4748L3.17931 17.6148L3.17922 17.6148L3.17321 17.6252C2.93309 18.041 2.80604 18.5124 2.8047 18.9926C2.80335 19.4728 2.92776 19.945 3.16555 20.3621C3.40334 20.7793 3.74621 21.1269 4.16006 21.3705C4.57391 21.614 5.04431 21.7449 5.52446 21.7502L5.52446 21.7502H5.53271H22.4727V21.7503L22.4809 21.7502C22.9611 21.7449 23.4315 21.614 23.8454 21.3705C24.2592 21.1269 24.6021 20.7793 24.8399 20.3621C25.0776 19.945 25.2021 19.4728 25.2007 18.9926C25.1994 18.5124 25.0723 18.041 24.8322 17.6252L24.8323 17.6251L24.8261 17.6148L16.3561 3.4748L16.3561 3.4748L16.354 3.47123C16.1088 3.06713 15.7637 2.73302 15.3519 2.50115C14.94 2.26927 14.4753 2.14746 14.0027 2.14746C13.5301 2.14746 13.0654 2.26927 12.6536 2.50115C12.2417 2.73302 11.8966 3.06713 11.6514 3.47123Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.54297V13.0001",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.8281H14.0095",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.a96ce5c9038c0a4eb3f26d3c388da0c4.svg";
export { ForwardRef as ReactComponent };